import {
    PRACTITIONER_PREFERENCES_LIST_REQUEST, PRACTITIONER_PREFERENCES_LIST_SUCCESS, PRACTITIONER_PREFERENCES_LIST_FAIL,
    PRACTITIONER_PREFERENCES_DETAILS_REQUEST, PRACTITIONER_PREFERENCES_DETAILS_SUCCESS, PRACTITIONER_PREFERENCES_DETAILS_FAIL, PRACTITIONER_PREFERENCES_DETAILS_RESET,
    PRACTITIONER_PREFERENCES_CREATE_REQUEST, PRACTITIONER_PREFERENCES_CREATE_SUCCESS, PRACTITIONER_PREFERENCES_CREATE_FAIL, PRACTITIONER_PREFERENCES_CREATE_RESET,
    PRACTITIONER_PREFERENCES_UPDATE_REQUEST, PRACTITIONER_PREFERENCES_UPDATE_SUCCESS, PRACTITIONER_PREFERENCES_UPDATE_FAIL, PRACTITIONER_PREFERENCES_UPDATE_RESET,
    PRACTITIONER_PREFERENCES_DELETE_REQUEST, PRACTITIONER_PREFERENCES_DELETE_SUCCESS, PRACTITIONER_PREFERENCES_DELETE_FAIL,
    PRACTITIONER_PREFERENCES_DTO_REQUEST, PRACTITIONER_PREFERENCES_DTO_SUCCESS, PRACTITIONER_PREFERENCES_DTO_FAIL, PRACTITIONER_PREFERENCES_DTO_RESET,
    SET_CURRENT_PAGE,
} from '../constants/applicationUserPreferencesConstants';

export const applicationUserPreferencesListReducer = (state = { applicationUserPreferences: [] }, action) => {
    switch (action.type) {
        case PRACTITIONER_PREFERENCES_LIST_REQUEST:
            return { loading: true, applicationUserPreferences: [] };
        case PRACTITIONER_PREFERENCES_LIST_SUCCESS:
            return {
                loading: false,
                applicationUserPreferences: action.payload.items,
                totalPages: action.payload.totalPages,
                currentPage: action.payload.currentPage,
                totalCount: action.payload.totalCount,
            };
        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.payload
            };
        case PRACTITIONER_PREFERENCES_LIST_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const applicationUserPreferencesDetailsReducer = (state = { applicationUserPreferences: {} }, action) => {
    switch (action.type) {
        case PRACTITIONER_PREFERENCES_DETAILS_REQUEST:
            return { loading: true, ...state };
        case PRACTITIONER_PREFERENCES_DETAILS_SUCCESS:
            return { loading: false, applicationUserPreferences: action.payload };
        case PRACTITIONER_PREFERENCES_DETAILS_FAIL:
            return { loading: false, error: action.payload };
        case PRACTITIONER_PREFERENCES_DETAILS_RESET:
            return { applicationUserPreferences: {} };
        default:
            return state;
    }
};

export const applicationUserPreferencesDtoReducer = (state = { applicationUserPreferencesDto: {} }, action) => {
    switch (action.type) {
        case PRACTITIONER_PREFERENCES_DTO_REQUEST:
            return { loading: true, applicationUserPreferencesDto: {} };
        case PRACTITIONER_PREFERENCES_DTO_SUCCESS:
            return { loading: false, applicationUserPreferencesDto: action.payload };
        case PRACTITIONER_PREFERENCES_DTO_FAIL:
            return { loading: false, error: action.payload };
        case PRACTITIONER_PREFERENCES_DTO_RESET:
            return { applicationUserPreferencesDto: {} };
        default:
            return state;
    }
};

export const applicationUserPreferencesDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case PRACTITIONER_PREFERENCES_DELETE_REQUEST:
            return { loading: true };
        case PRACTITIONER_PREFERENCES_DELETE_SUCCESS:
            return { loading: false, success: true };
        case PRACTITIONER_PREFERENCES_DELETE_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const applicationUserPreferencesCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case PRACTITIONER_PREFERENCES_CREATE_REQUEST:
            return { loading: true };
        case PRACTITIONER_PREFERENCES_CREATE_SUCCESS:
            return { loading: false, success: true, applicationUserPreferences: action.payload };
        case PRACTITIONER_PREFERENCES_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case PRACTITIONER_PREFERENCES_CREATE_RESET:
            return {};
        default:
            return state;
    }
};

export const applicationUserPreferencesUpdateReducer = (state = { applicationUserPreferences: {} }, action) => {
    switch (action.type) {
        case PRACTITIONER_PREFERENCES_UPDATE_REQUEST:
            return { loading: true };
        case PRACTITIONER_PREFERENCES_UPDATE_SUCCESS:
            return { loading: false, success: true, applicationUserPreferences: action.payload };
        case PRACTITIONER_PREFERENCES_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case PRACTITIONER_PREFERENCES_UPDATE_RESET:
            return { applicationUserPreferences: {} };
        default:
            return state;
    }
}; 